module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07426_logo_200x200.61f9d19f.png";